// app/global-error.tsx
"use client";

import { useEffect } from "react";
import Link from "next/link";
import Footer from "@/app/components/themes/Footer";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("خطای سرور:", error);
  }, [error]);

  const menuItems = [
    { href: "/", label: "صفحه اصلی" },
    { href: "/properties", label: "املاک" },
    { href: "/builders", label: "انبوه" },
    { href: "/properties/requester", label: "فرم متقاضی" },
    { href: "/blog", label: "وبلاگ" },
    { href: "/contact", label: "تماس با ما" },
    { href: "/aboutus", label: "درباره ما" },
  ];

  return (
    <html lang="fa" dir="rtl">
      <body className="bg-[var(--background)] text-[var(--colorinput)]">
        {/* هدر سمت کاربر */}
        <header className="header hidden md:flex fixed top-10 justify-around xl:w-[80%] text-[var(--headertext)] lg:w-[95%] md:w-[95%] w-[95%] h-28 xl:right-[10%] lg:right-[2.5%] md:right-[2.5%] right-[2.5%] bg-[var(--headerback)] shadow-[var(--headershadow)] font-modam rounded-2xl z-100">
          <div className="logo w-35 flex items-center gap-3">
            <img
              src="/media/user.png"
              alt="pol logo"
              className="w-15 yeshadow"
            />
            <h2 className="font-bold text-2xl text-nowrap text-[var(--title)]">پول املک</h2>
          </div>
          <nav className="flex items-center justify-center">
            <ul className="flex gap-10 lg:text-xm text-sm">
              {menuItems.map((item) => (
                <li
                  key={item.href}
                  className="text-[var(--headertext)]"
                >
                  <Link href={item.href}>{item.label}</Link>
                </li>
              ))}
            </ul>
          </nav>
          <div className="buttons flex xl:gap-10 gap-10 items-center">
            <Link href={'/login'} className="btngoldB ccdiv w-40 h-12 p-0 cursor-pointer text-[var(--headertext)]">
              ورود
            </Link>
          </div>
        </header>

        {/* نسخه موبایل هدر */}
        {/* <header className="header md:hidden flex flex-col justify-start items-start px-6 fixed overflow-hidden top-[1%] left-[2%] w-[96%] h-20 rounded-lg bg-[var(--headerback)] shadow-[var(--headershadow)] z-1000">
          <div className="hed w-full min-h-20 flex justify-around items-center">
            <div className="w-[100%] logo gap-2 flex justify-center items-center">
              <img src="/media/user.png" alt="pol logo" className="w-[45px] md:w-[15%]" />
              <h2 className="text-2xl font-bold text-[var(--title)] text-center">پول املک</h2>
            </div>
          </div>
        </header> */}

        <div className="min-h-[70vh] flex items-center justify-center px-4 py-20 mt-32">
          <div className="text-center max-w-md mx-auto">
            <div className="text-9xl font-bold text-red-500 mb-4">500</div>
            <div className="w-24 h-1 bg-gradient-to-r from-transparent via-red-500 to-transparent mx-auto my-6"></div>
            <h1 className="text-2xl font-bold text-[var(--titleha)] mb-3">خطای داخلی سرور</h1>
            <p className=" text-[var(--colorinput)] mb-8">
              مشکلی در سرور رخ داده است. لطفاً مجدداً تلاش کنید یا بعداً مراجعه نمایید.
            </p>
            <div className="flex flex-wrap gap-4 justify-center">
              <button
                onClick={() => reset()}
                className="subBtnRe px-6 py-3 rounded-lg transition-all"
              >
                <i className="ri-refresh-line ml-2"></i>
                تلاش مجدد
              </button>
              <Link
                href="/"
                className="normBtn px-6 py-3 rounded-lg transition-all"
              >
                <i className="ri-home-line ml-2"></i>
                بازگشت به خانه
              </Link>
            </div>
          </div>
        </div>
        <Footer />
      </body>
    </html>
  );
}